import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { PageWrapper } from "../components/PageWrapper";
import { Navbar } from "../Navbar";
import { PlacementCandidatePage } from "../PlacementCandidate/Page";

export function PlacementsRootPage({ hidden }: { hidden?: boolean }) {
  const worker = useDefinedWorker();

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />

      <PageWrapper
        sx={{
          ...(hidden && { display: "none" }),
          ...getSafeAreaPaddings({
            top: true,
          }),
          // hack to force the safe area background color to be the same as the page background color
          backgroundColor: (theme) => theme.palette.background.tertiary,
        }}
      >
        <PlacementCandidatePage worker={worker} />

        <Navbar />
      </PageWrapper>
    </ThemeProvider>
  );
}
